import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SortOrder } from '../../../Utils/Constants';

export class HeaderSortComponent extends Component {
  static propTypes = {
    headerTitle: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    sortOrderOverride: PropTypes.oneOf([SortOrder.ASC, SortOrder.DESC])
  };

  render() {
    const { headerTitle, onClick, sortOrderOverride } = this.props;
    return (
      <span
        className={`d-flex align-items-center ${HeaderSortComponent.getSortOrderClass(sortOrderOverride)} ${
          onClick ? 'cursor-pointer' : ''
        }`}
        onClick={() => {
          onClick && onClick();
        }}>
        {headerTitle}
        &nbsp;
        <div className="react-table-header-sort-icon">
          <i className="togo-icon togo-icon-lg togo-icon-chevron togo-icon-flip-vertical vertical-chevron" />
          <i className="togo-icon togo-icon-lg togo-icon-chevron horizontal-chevron" />
        </div>
      </span>
    );
  }

  static getSortOrderClass(override) {
    switch (override) {
      case SortOrder.ASC:
        return 'sort-override-asc';
      case SortOrder.DESC:
        return 'sort-override-desc';
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/Scss/Custom/ReactTable/HeaderSortComponent.js